import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  UncontrolledTooltip,
} from 'reactstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';
import DataEmptyState from '../../../commons/dataemptystate';
import NetworkEmptyState from '../../../commons/networkemptystate';
import Loader from '../../../commons/loader';
import Services from '../services';
import FunkcioKedvezmenyForm from './FunkcioKedvezmenyForm';
import { PaginationTotal } from '../../../commons/controls';
import { ProgressButton } from '../../../commons/ProgressButton';
import Lib from '../../../commons/lib';
import RFForm from '../../../components/Form/RFForm';

class FunkcioKedvezmenyContent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // ['LOAD', 'DATA', 'NETW', 'TABL']
      tableStatus: 'TABL',
      // ['LOAD', 'DATA', 'NETW']
      viewStatus: 'DATA',
      // ['LOAD', 'DATA', 'NETW']
      formStatus: 'DATA',
      
      // DATA
      baseJson: [],
      viewObj: {},
      currentId: undefined,
      torlesId: undefined,

      // FORM
      formFunkcio: null,
      formKedvezmenyek: [],

      // MODAL UTILS
      formTypeStatus: false,
      modalView: false,
      modalDelete: false,
      modalForm: false,
      saveButtonLoading: false,
      deleteButtonLoading: false,
    };
  }

  componentDidUpdate(prevProps) {
    if(this.props.active !== prevProps.active){
      if(this.props.active){
        this.listFunkcioKedvezmeny();
      }
    }
  }

  toggleDeleteModal = () => {
    this.setState(prevState => ({ modalDelete: !prevState.modalDelete }));
  }

  toggleViewModal = () => {
    this.setState(prevState => ({ modalView: !prevState.modalView }));
  }

  toggleFormModal = () => {
    this.setState(prevState => ({ modalForm: !prevState.modalForm }));
  }

  listFunkcioKedvezmeny = () => {
    this.setState({
      tableStatus: 'LOAD'
    }, () => {
      Services.listFunkcioKedvezmeny((err, res) => {
        if (!err) {
          this.setState({
            tableStatus: res[0].length > 0 ? 'TABL' : 'DATA',
            baseJson: res[0],
          });
        } else {
          this.setState({
            tableStatus: 'NETW'
          });
        }
      });
    });
  }

  getFunkcioKedvezmenyView = (id) => {
    this.setState({
      viewStatus: 'LOAD',
    }, () => {
      Services.getFunkcioKedvezmeny(id, (err, res) => {
        if (!err) {
          this.setState({
            viewObj: res[0],
            viewStatus: 'DATA',
          });
        } else {
          this.setState({
            viewStatus: 'NETW'
          });
        }
      });
    });
  }

  getFunkcioKedvezmenyForm = (id) => {
    this.setState({
      formStatus: 'LOAD',
    }, () => {
      Services.getFunkcioKedvezmeny(id, (err, res) => {
        if (!err) {
          this.setState({
            formStatus: 'DATA',
            formFunkcio: res[0].funkcio,
            formKedvezmenyek: res[0].kedvezmenyek,
          });
        } else {
          this.setState({
            formStatus: 'NETW'
          });
        }
      });
    });
  }

  saveFunkcioKedvezmeny = () => {
    const {
      currentId,
      formTypeStatus,
      formFunkcio,
      formKedvezmenyek,
    } = this.state;

    this.setState({
      saveButtonLoading: true
    }, () => {
      if (formTypeStatus == 'FEL') {
        let submitObj = {};
        submitObj.kedvezmenyIds = formKedvezmenyek.map( k => k.id);
        submitObj.funkcioId = formFunkcio && formFunkcio.id;
  
        Services.addFunkcioKedvezmeny(submitObj, (err) => {
          if (!err) {
            this.props.globals.addSuccess('Funkció kedvezmény felvéve!');
            this.toggleFormModal();
            this.listFunkcioKedvezmeny();
            this.setState({
              saveButtonLoading: false
            });
          } else {
            this.setState({
              saveButtonLoading: false
            });
          }
        });
      } else if(formTypeStatus == 'MOD') {
        let submitObj = {};
  
        submitObj.id =  formFunkcio.id;
        submitObj.kedvezmenyIds = formKedvezmenyek.map( k => k.id);
        submitObj.funkcioId = formFunkcio && formFunkcio.id;
        
        Services.editFunkcioKedvezmeny(submitObj, (err) => {
          if (!err) {
            this.props.globals.addSuccess('Funkció kedvezmény módosítva!');
            this.toggleFormModal();
            this.listFunkcioKedvezmeny();
            this.setState({
              saveButtonLoading: false
            });
          } else {
            this.setState({
              saveButtonLoading: false
            });
          }
        });
      }
    });
  }


  deleteFunkcioKedvezmeny = () => {
    this.setState({
      deleteButtonLoading: true
    }, () => {
      //const funckioId = this.state.baseJson.find( f => f.id == this.state.torlesId).funkcio.id;
      Services.deleteFunkcioKedvezmeny(this.state.torlesId, (err) => {
        if (!err) {
          this.toggleDeleteModal();
          this.listFunkcioKedvezmeny();
          this.props.globals.addSuccess('Funkció kedvezmény törölve!');
          this.setState({
            deleteButtonLoading: false
          });
        } else {
          this.setState({
            deleteButtonLoading: false
          });
        }
      });
    });
  }

  handleNewClick = () => {
    this.setState({
      currentId: null,
      formStatus: 'DATA',
      formTypeStatus: 'FEL',
      formFunckio: null,
      formKedvezmenyek: [],
    }, () => this.toggleFormModal());
  }

  handleEditClick = (id) => {
    this.setState({
      formTypeStatus: 'MOD',
      formStatus: 'LOAD',
      currentId: id,
    }, () => {
      this.getFunkcioKedvezmenyForm(id);
      this.toggleFormModal();
    });
  }

  handleViewClick = (id) => {
    this.setState({
      formStatus: 'LOAD',
      currentId: id,
    }, () => {
      this.getFunkcioKedvezmenyView(id, false);
      this.toggleViewModal();
    });
  }

  handleDeleteClick = (id) => {
    this.setState({
      torlesId: id
    }, () => {
      this.toggleDeleteModal();
    });
  }

  handleSelectInputChange = (v, name) => {
    const value = v === '' ? null : v;
    this.setState({
      [name]: value
    });
  }


  tableIconFormatter = (cell, row) => {
    return (
      <div>
        {this.props.globals.hasRole(['KEDVEZMENY_FUNKKEDV']) && (
          <React.Fragment>
            <Button className="icon-eye table-action-icon" id={'action-view-' + cell + 'megtekint'} onClick={() => this.handleViewClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
            <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'megtekint'} delay={50}>
              {'Megtekintés'}
            </UncontrolledTooltip>
          </React.Fragment>
        )}
        {/* {this.props.globals.hasRole(['KEDVEZMENY_FUNKKEDV'], true) && (
          <React.Fragment>
            <Button className="icon-pencil table-action-icon" id={'action-view-' + cell + 'modositas'} onClick={() => this.handleEditClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
            <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'modositas'} delay={50}>
              {'Módosítás'}
            </UncontrolledTooltip>
            <Button className="icon-trash table-action-icon" id={'action-view-' + cell + 'delete'} onClick={() => this.handleDeleteClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
            <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'delete'} delay={50}>
            {'Törlés'}
            </UncontrolledTooltip>
          </React.Fragment>
        )} */}
      </div>
    );
  }

  renderView = () => {
    const {
      viewObj
    } = this.state;

    return (
      <div>
        <h6>Funkció-kedvezmény:</h6>
        <b>Funkció: </b>
        {viewObj && viewObj.funkcio && viewObj.funkcio.nev}
        <br />
        <b>Kedvezmények: </b>
        {viewObj && viewObj.kedvezmenyNevek}
      </div>
    );
  }

  renderTable = () => {
    const options = {
      sizePerPage: 5,
      showTotal: true,
      paginationTotalRenderer: PaginationTotal,
      sizePerPageList: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '25', value: 25 }
      ],
    };

    const columns = [
      {
        dataField: 'funkcio.nev',
        text: 'Funkció',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-word',
          whiteSpace: 'pre-line',
        },
        sort: true
      },
      {
        dataField: 'kedvezmenyNevek',
        text: 'Kedvezmények',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-word',
          whiteSpace: 'pre-line',
        },
        sort: true
      },
      {
        dataField: 'id',
        text: 'Műveletek',
        formatter: this.tableIconFormatter
      }
    ];

    return (
        <div className="animated fadeIn">
          <BootstrapTable
            bootstrap4
            keyField="id"
            data={this.state.baseJson}
            columns={columns}
            filter={filterFactory()}
            pagination={paginationFactory(Lib.bootstraptableProps)}
            noDataIndication="Nincs megjelenítendő adat!"
          />
        </div>
    );
  }

  renderTableView = () => {
    return(
      <div className="col-md-12">
        {{
          LOAD: (<Loader />),
          DATA: (<DataEmptyState
            hasImage
            subtitle="Vigyél fel új tételt!"
          />),
          NETW: (<NetworkEmptyState
            hasImage
            submitClick={() => this.listFunkcioKedvezmeny()}
          />),
          TABL: (this.renderTable())
        }[this.state.tableStatus]}
      </div>
    );
  }

  renderModals = () => {
    return(
      <React.Fragment>
        <Modal isOpen={this.state.modalDelete} toggle={this.toggleDeleteModal} backdrop="static">
          <ModalHeader>Törlés</ModalHeader>
          <ModalBody>Valóban törölni kívánod a kiválasztott tételt?</ModalBody>
          <ModalFooter>
            <ProgressButton
              className="btn-cursor-pointer"
              color="primary"
              onClick={() => this.deleteFunkcioKedvezmeny()}
              loading={this.state.deleteButtonLoading}
            >
              {'Igen'}
            </ProgressButton>
            <Button type="button" color="secondary" onClick={this.toggleDeleteModal}>Mégsem</Button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={this.state.modalView} toggle={this.toggleViewModal} backdrop="static">
          <ModalHeader>
            {'Megtekintés'}
          </ModalHeader>
          <ModalBody>
            {{
              LOAD: (<Loader />),
              NETW: (<NetworkEmptyState
                hasImage
                submitClick={() => this.getFunkcioKedvezmenyView(this.state.currentId)}
              />),
              DATA: (this.renderView())
            }[this.state.viewStatus]}
          </ModalBody>
          <ModalFooter>
            <Button type="button" color="secondary" className="btn-cursor-pointer" onClick={this.toggleViewModal}>Vissza</Button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={this.state.modalForm} toggle={this.toggleFormModal} backdrop="static">
          <RFForm
            modal
            onSubmit={this.saveFunkcioKedvezmeny}
            title={this.state.formTypeStatus == 'FEL' ? 'Funkció-kedvezmény rögzítése': 'Funkció-kedvezmény módosítása'}
            footer={
              <>
                <ProgressButton
                className="btn-cursor-pointer"
                color="primary"
                loading={this.state.saveButtonLoading}
              >
                {'Mentés'}
              </ProgressButton>
              <Button type="button" color="secondary" onClick={this.toggleFormModal}>Mégsem</Button>
              </>
            }
          >
            {{
              LOAD: (
                <Loader />
              ),
              NETW: (
                <NetworkEmptyState
                  hasImage
                  submitClick={() => this.getFunkcioKedvezmenyForm(this.state.currentId)}
                />),
              DATA: 
                <FunkcioKedvezmenyForm 
                  modositas={!!this.state.currentId}
                  formFunkcio={this.state.formFunkcio}
                  formKedvezmenyek={this.state.formKedvezmenyek}
                  handleSelectInputChange={this.handleSelectInputChange}
                />
            }[this.state.formStatus]}
          </RFForm>
        </Modal>
    </React.Fragment>
    );
  }

  render = () => {
    return (
      <React.Fragment>
        <div className="row">
          <div className="col-md-12">
            {/* {this.props.globals.hasRole(['KEDVEZMENY_FUNKKEDV'], true) && (
              <Button className="pull-left table-new-button" color="primary" onClick={this.handleNewClick}>
                {'Új funkció-kedvezmény'}
              </Button>
            )} */}
          </div>
          {this.renderTableView()}
        </div>
        {this.renderModals()}
      </React.Fragment>
    );
  }
}

FunkcioKedvezmenyContent.propTypes = {
  globals: PropTypes.object
};

export default FunkcioKedvezmenyContent;